/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
} from './Asset';

/**
 * 
 * @export
 * @interface EnrichedAsset
 */
export interface EnrichedAsset {
    /**
     * 
     * @type {Asset}
     * @memberof EnrichedAsset
     */
    asset: Asset;
    /**
     * 
     * @type {string}
     * @memberof EnrichedAsset
     */
    lastHeldDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedAsset
     */
    isLiveHeld?: boolean;
}

/**
 * Check if a given object implements the EnrichedAsset interface.
 */
export function instanceOfEnrichedAsset(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;

    return isInstance;
}

export function EnrichedAssetFromJSON(json: any): EnrichedAsset {
    return EnrichedAssetFromJSONTyped(json, false);
}

export function EnrichedAssetFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrichedAsset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': AssetFromJSON(json['asset']),
        'lastHeldDate': !exists(json, 'last_held_date') ? undefined : json['last_held_date'],
        'isLiveHeld': !exists(json, 'is_live_held') ? undefined : json['is_live_held'],
    };
}

export function EnrichedAssetToJSON(value?: EnrichedAsset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': AssetToJSON(value.asset),
        'last_held_date': value.lastHeldDate,
        'is_live_held': value.isLiveHeld,
    };
}

